import './AddToBasketButton.scss';

import React from 'react';

const AddToBasketLoadingSpinner = () => (
	<div
		className="add-to-basket-loading-spinner"
		data-testid="add-to-basket-loading-spinner">
		<div className="add-to-basket-loading-spinner__animation" />
	</div>
);

export default AddToBasketLoadingSpinner;
